export const RESULT_RESET_STATE = 'RESULT_RESET_STATE';
export const RESULT_SET_COLUMNS = 'RESULT_SET_COLUMNS';
export const RESULT_SET_COLUMN_ATTRIBUTES = 'RESULT_SET_COLUMN_ATTRIBUTES';
export const RESULT_SET_ROWS = 'RESULT_SET_ROWS';
export const RESULT_SET_ROWS_COUNT = 'RESULT_SET_ROWS_COUNT';
export const RESULT_SET_ROWS_TOTAL_COUNT = 'RESULT_SET_ROWS_TOTAL_COUNT';
export const RESULT_SET_PAGE = 'RESULT_SET_PAGE';
export const RESULT_SET_PAGE_SIZE = 'RESULT_SET_PAGE_SIZE';
export const RESULT_SET_GROUP = 'RESULT_SET_GROUP';
export const RESULT_TOGGLE_GROUP_ROW = 'RESULT_TOGGLE_GROUP_ROW';
export const RESULT_SET_CHECK_SATE = 'RESULT_SET_CHECK_SATE';
export const RESULT_TOGGLE_CHECKED_ROW = 'RESULT_TOGGLE_CHECKED_ROW';
